import { render, staticRenderFns } from "./purchaseGroup.vue?vue&type=template&id=e38d45e6&scoped=true"
import script from "./purchaseGroup.vue?vue&type=script&lang=js"
export * from "./purchaseGroup.vue?vue&type=script&lang=js"
import style0 from "./purchaseGroup.vue?vue&type=style&index=0&id=e38d45e6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e38d45e6",
  null
  
)

export default component.exports